import React from "react";

import LogoSpin from "../icons/protectdotngo-logo.png";

export default function Loading() {
  return (
    <div className="fixed top-16 bottom-0 flex flex-col justify-center items-center bg-gray-50 bg-opacity-80 w-screen z-50">
      <img
        className="w-64 h-auto animate-pulse"
        src={LogoSpin}
        alt=""
        style={{ transformOrigin: "50% 50%" }}
      />
      <p className="mt-4 text-cpi font-bold">Crunching data...</p>
    </div>
  );
}
